import { useAction, useAtom } from '@reatom/npm-react'

import { AsyncStateN } from '@blade/std-lib'

import { UserTradingAnalyticsPriceType } from '../../models/user-trading-analytics-price-type'

import { Analysis } from './analysis'
import { AnalysisError } from './analysis-error'
import { AnalysisSkeleton } from './analysis-skeleton'

import type { UserTradingAnalyticsModel } from '../../atoms'

type Props = {
  model: UserTradingAnalyticsModel
}

const balanceTypeToPriceType: Record<
  UserTradingAnalyticsPriceType,
  'usd' | 'native'
> = {
  [UserTradingAnalyticsPriceType.USD]: 'usd',
  [UserTradingAnalyticsPriceType.NATIVE]: 'native',
}

export const AnalysisBlock = ({ model }: Props) => {
  const [analyticsState] = useAtom(model.requestStateAtom)
  const [priceType] = useAtom(model.priceTypeAtom)

  const onRetry = useAction(model.requestStateAtom.refresh)

  return AsyncStateN.matchWaiting(analyticsState, {
    Success: (data) => (
      <Analysis data={data} balanceType={balanceTypeToPriceType[priceType]} />
    ),
    Error: () => <AnalysisError onRetry={onRetry} />,
    Waiting: () => <AnalysisSkeleton rows={7} />,
  })
}
